<section class="container flex flex-col items-center justify-center mx-auto p-4 mt-20">
  <div class="backdrop-blur-lg bg-white/10 border border-white/20 rounded-3xl shadow-2xl p-8 max-w-xl w-full flex flex-col items-center">
    <a routerLink="/"
      class="self-start flex items-center gap-1.5 py-2 mb-4 rounded-2xl text-gray-500 font-small hover:text-gray-900 transition-colors">
      <ng-icon name="heroArrowLeft" size="18"></ng-icon>
      <span>Back to home</span>
    </a>
    <div class="text-center mb-8">
      <img [src]="userInfo?.avatar_url" alt="User image"
        class="w-48 h-48 rounded-full mx-auto mb-4 border-1 border-white shadow-lg">
      <h1 class="text-3xl font-semibold text-White mb-2">Welcome, {{ userInfo?.name }}</h1>
      <p class="text-gray-400 text-lg">{{ userInfo?.email }}</p>
    </div>

    <div class="w-full max-w-md bg-gradient-to-br from-green-50 to-green-100 rounded-2xl p-8 text-center shadow-sm">
      <div class="mb-6">
        @if(percentageUsed !== null && percentageUsed !== undefined) {
          <h1 class="text-6xl font-bold text-green-600 mb-2">{{ percentageUsed }}%</h1>
          <p class="text-gray-600 text-sm">Remaining</p>
        } @else {
          <div class="flex flex-col items-center justify-center py-4">
            <div class="animate-spin rounded-full h-16 w-16 border-b-2 border-[#1594fd] mb-4"></div>
            <p class="text-gray-600 text-sm">Loading usage data...</p>
          </div>
        }
      </div>

      <div class="flex items-center justify-center space-x-2">
        <svg class="w-4 h-4 text-amber-500" fill="currentColor" viewBox="0 0 20 20">
          <path
            d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z">
          </path>
        </svg>
        <span class="text-lg text-gray-600">Subscription Plan</span>
        <span class="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-2 py-1 rounded-full">Premium</span>
      </div>
    </div>
  </div>
</section>
